import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RoleUserTiamDto } from '../domain/models/roleTiam';

@Injectable({ providedIn: 'root' })
export class UserRolesService  {
  private rolesSubject = new BehaviorSubject<RoleUserTiamDto[]>([]);
  public roles$: Observable<RoleUserTiamDto[]> = this.rolesSubject.asObservable();

  setRoles(roles: RoleUserTiamDto[]): void {
    this.rolesSubject.next(roles);
  }

  getRoles(): RoleUserTiamDto[] {
    return this.rolesSubject.getValue();
  }

  hasRole(roleName: string): boolean {
    return this.getRoles().some(r => r.role === roleName);
  }
}


